import gql from 'graphql-tag';

import personFragment from '../fragments/personFragment';

export const queryPerson = gql`
  query person {
    person {
      ...personFragment
    }
  }
  ${personFragment}
`;
export default queryPerson;
